import { render, staticRenderFns } from "./DischargeEditor.vue?vue&type=template&id=1a93477a&scoped=true&"
import script from "./DischargeEditor.vue?vue&type=script&lang=js&"
export * from "./DischargeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a93477a",
  null
  
)

export default component.exports